<footer class="footer">
    <div class="footer-content">
      <div class="footer-section about">
        <h2>About Us</h2>
        <p>
          We are your go-to resource for all things Angels Online. Our team updates the wiki daily to keep up with the latest game version and provide you with the most accurate and up-to-date information.
        </p>
      </div>
      <div class="footer-section links">
        <h2>Quick Links</h2>
        <ul>
          <li><a href="https://megabanana.mx/">Megabanana</a></li>
          <li><a href="https://www.wikiangelsonline.com/">Wiki Angels Online</a></li>
        </ul>
      </div>
      <div class="footer-section contact">
        <h2>Contact Information</h2>
        <p>Email: kerrox16&#64;wikiangelsonline.com</p>
        <p>Discord: kerro16</p>
      </div>
    </div>
    <div class="footer-bottom">
      &copy; 2025 Redemptionware. All rights reserved.
    </div>
  </footer>